import { Component } from 'react';
import { connect } from 'react-redux';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { H5 } from 'foundations-components/transitional/components/H5';
import { ONE_HOUR } from 'MeetingsBase/constants/dates';
import { getCustomParams as getCustomParamsSelector, getEvent as getEventSelector, getPaidMeetingsAvailableSelector, getPaymentLinkInfo } from 'MeetingsLib/selectors/BookInfoSelectors';
import { setEventDuration } from 'MeetingsLib/redux/actions/FormActions';
import { HiddenAriaStatus } from 'MeetingsLib/components/decorative/HiddenAriaStatus';
import PaidMeetingPrice from '../../payments/PaidMeetingPrice';
import { getPaymentSuccessfulSelector, getPaidMeetingPrice } from '../../../selectors/PaymentStatusSelectors';
import { DurationOptionsGrid } from './DurationOptionsGrid';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class DurationPicker extends Component {
  constructor(...args) {
    super(...args);
    this.handleSetEventDuration = ({
      target: {
        value
      }
    }) => {
      this.props.setEventDuration(value);
    };
    this.getCompoundTime = (hours, minutes) => {
      const hourString = I18n.text('prebook.durationPicker.shortHourCount', {
        count: Math.floor(hours)
      });
      const minuteString = I18n.text('prebook.durationPicker.minuteCount', {
        count: minutes
      });
      return I18n.text('prebook.durationPicker.combination', {
        hours: hourString,
        minutes: minuteString
      });
    };
    this.getHours = hours => {
      return I18n.text('prebook.durationPicker.hourCount', {
        count: hours
      });
    };
    this.getMinutes = minutes => {
      return I18n.text('prebook.durationPicker.minuteCount', {
        count: minutes
      });
    };
    this.getDurationOptionText = duration => {
      const minutes = I18n.moment.duration(duration).asMinutes();
      if (duration >= ONE_HOUR) {
        const remainderMinutes = I18n.moment.duration(minutes % 60).valueOf();
        const hours = I18n.moment.duration(duration).asHours();
        if (remainderMinutes !== 0) {
          // @ts-expect-error fix type
          return this.getCompoundTime(hours, remainderMinutes);
        } else {
          return this.getHours(hours);
        }
      }
      return this.getMinutes(minutes);
    };
    this.getButtonGroupOptions = durationOptions => {
      return durationOptions.map(duration => ({
        text: this.getDurationOptionText(duration),
        value: duration
      })).toJS();
    };
    this.renderDurationPickerHeader = durationOptions => {
      const durationHeader = durationOptions.size === 1 ? 'prebook.durationPicker.header.singular' : 'prebook.durationPicker.header.plural';
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: durationHeader
      });
    };
    this.renderPaidMeetingHeader = () => {
      const {
        isPaidMeeting,
        paidMeetingInfo,
        paidMeetingPrice,
        paymentSuccessful
      } = this.props;
      if (!isPaidMeeting) {
        return null;
      }
      return /*#__PURE__*/_jsx(PaidMeetingPrice
      /*  @ts-expect-error Jun-30-2025, 19:10UTC fix runtime - paidMeetingPrice potentially undefined */, {
        price: paidMeetingPrice,
        paid: paymentSuccessful
        /*  @ts-expect-error Jun-30-2025, 19:10UTC fix runtime - paidMeetingInfo potentially undefined */,
        currency: paidMeetingInfo.currency
      });
    };
    this.renderDurationPicker = durationOptions => {
      const buttonGroupOptions = this.getButtonGroupOptions(durationOptions);
      return /*#__PURE__*/_jsxs(TFlex, {
        flexGrow: "1",
        flexShrink: "0",
        flexBasis: "0",
        paddingBlockStart: "800",
        paddingInline: "800",
        inlineSize: "100%",
        direction: "column",
        display: "flex",
        children: [this.renderPaidMeetingHeader(), /*#__PURE__*/_jsx(H5, {
          id: "meeting-duration",
          children: this.renderDurationPickerHeader(durationOptions)
        }), /*#__PURE__*/_jsx(DurationOptionsGrid, {
          onChange: this.handleSetEventDuration,
          options: buttonGroupOptions,
          value: this.props.selectedDuration
        }), /*#__PURE__*/_jsx(HiddenAriaStatus, {
          role: "status",
          "aria-live": "polite",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "accessible.durationStatus",
            options: {
              selectedDuration: this.getDurationOptionText(this.props.selectedDuration),
              /*  @ts-expect-error Jun-30-2025, 19:10UTC fix runtime - selectedDate potentially null */
              selectedDate: I18n.moment(this.props.selectedDate).format('MMMM Do')
            }
          })
        })]
      });
    };
  }
  render() {
    const {
      durationOptions
    } = this.props;
    if (!durationOptions || durationOptions.size === 0) {
      return null;
    }
    return this.renderDurationPicker(durationOptions);
  }
}
const mapStateToProps = state => ({
  selectedDuration: getEventSelector(state).duration,
  selectedDate: getEventSelector(state).dateString,
  durationOptions: getCustomParamsSelector(state).durations,
  isPaidMeeting: getPaidMeetingsAvailableSelector(state),
  // @ts-expect-error Jun-30-2025, 19:10UTC fix types
  paidMeetingInfo: getPaymentLinkInfo(state),
  paymentSuccessful: getPaymentSuccessfulSelector(state),
  paidMeetingPrice: getPaidMeetingPrice(state)
});
export default connect(mapStateToProps, {
  setEventDuration
})(DurationPicker);